import { useState } from 'react';

import PropTypes from 'prop-types';

import Button from '#globalComponents/Button/Button';
import FormField from '#globalComponents/Forms/FormField';
import TextInput from '#globalComponents/Forms/TextInput';
import { getErrorMessage } from '#lib/errors/errorMessages';
import { useSetMemberBudget } from '#orgFeature/models/org/mutations';

export const MemberBudgetEditor = ({ member, onClose }) => {
	const [companyBudget, setCompanyBudget] = useState(member.companyMonthlyBudget ?? 0);
	const [contactBudget, setContactBudget] = useState(member.contactMonthlyBudget ?? 0);

	const budgetMutation = useSetMemberBudget();

	const handleSave = () => {
		budgetMutation.mutate(
			{
				userId: member.userId,
				companyMonthlyBudget: Number(companyBudget),
				contactMonthlyBudget: Number(contactBudget),
			},
			{ onSuccess: onClose },
		);
	};

	return (
		<div className="mt-3 space-y-3 rounded-card border border-primary-200 bg-primary-100 p-4">
			<h4 className="text-sm font-semibold text-text">Budget bearbeiten</h4>
			<div className="grid gap-3 sm:grid-cols-2">
				<FormField label="Firmen-Credits / Monat" htmlFor={`budget-company-${member.userId}`}>
					<TextInput
						id={`budget-company-${member.userId}`}
						type="number"
						min="0"
						value={companyBudget}
						onChange={(e) => setCompanyBudget(e.target.value)}
					/>
				</FormField>
				<FormField label="Kontakt-Credits / Monat" htmlFor={`budget-contact-${member.userId}`}>
					<TextInput
						id={`budget-contact-${member.userId}`}
						type="number"
						min="0"
						value={contactBudget}
						onChange={(e) => setContactBudget(e.target.value)}
					/>
				</FormField>
			</div>
			{budgetMutation.isError && (
				<p className="text-xs text-warning-700">{getErrorMessage(budgetMutation.error)}</p>
			)}
			<div className="flex justify-end gap-2">
				<Button variant="outline" size="sm" onClick={onClose}>
					Abbrechen
				</Button>
				<Button size="sm" onClick={handleSave} loading={budgetMutation.isPending}>
					Speichern
				</Button>
			</div>
		</div>
	);
};

MemberBudgetEditor.propTypes = {
	member: PropTypes.shape({
		userId: PropTypes.string.isRequired,
		companyMonthlyBudget: PropTypes.number,
		contactMonthlyBudget: PropTypes.number,
	}).isRequired,
	onClose: PropTypes.func.isRequired,
};
